"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnityInstance = void 0;
exports.LoadUnity = LoadUnity;
const jquery_1 = __importDefault(require("jquery"));
const UnityComm_1 = require("../utils/UnityComm");
require("../scss/unityLoadingStyles.scss");
const canvasid = "unity-canvas";
exports.UnityInstance = null;
/** Unity progress loader UI and loaded init handling */
function LoadUnity() {
    const loader = `<div id="loading-cover">
                      <div id="logo"></div> 
                      <div id="unity-loading-bar">        
                      <div id="unity-progress-bar-empty" ></div>
                          <div id="unity-progress-bar-full"></div>
                      </div>
                      <div class="spinner"></div>
                    </div> </div>`;
    (0, jquery_1.default)("body").prepend((0, jquery_1.default)(loader));
    const location = window.location.pathname;
    const path = location.substring(0, location.lastIndexOf("/"));
    const folderName = path.substring(path.lastIndexOf("/") + 1);
    const canvas = document.createElement("canvas");
    const buildsUrl = "Builds/";
    const buildFolder = "/Build/";
    const loaderUrl = buildsUrl + "UnityLoader.js";
    const config = {
        dataUrl: buildsUrl + folderName + buildFolder + folderName + ".data.gz",
        frameworkUrl: buildsUrl + folderName + buildFolder + folderName + ".framework.js.gz",
        codeUrl: buildsUrl + folderName + buildFolder + folderName + ".wasm.gz",
        streamingAssetsUrl: "StreamingAssets",
        companyName: "BCIT SOH",
        productName: "MTV_HeartLungMachine",
        productVersion: "0.1",
    };
    const loadingCover = document.querySelector("#loading-cover");
    const progressBarEmpty = document.querySelector("#unity-progress-bar-empty");
    const progressBarFull = document.querySelector("#unity-progress-bar-full");
    const spinner = document.querySelector(".spinner");
    const script = document.createElement("script");
    canvas.setAttribute("id", canvasid);
    document.body.appendChild(canvas);
    script.src = loaderUrl;
    script.onload = () => {
        if (/iPhone|iPad|iPod|Android/i.test(navigator.userAgent)) {
            // Mobile device style: fill the whole browser client area with the game canvas:
            var meta = document.createElement("meta");
            meta.name = "viewport";
            meta.content =
                "width=device-width, height=device-height, initial-scale=1.0, user-scalable=no, shrink-to-fit=yes";
            document.getElementsByTagName("head")[0].appendChild(meta);
        }
        window.createUnityInstance(canvas, config, (progress) => {
            spinner.style.display = "none";
            progressBarEmpty.style.display = "";
            progressBarFull.style.width = `${100 * progress}%`;
        })
            .then((unityInstance) => {
            loadingCover.style.display = "none";
            exports.UnityInstance = unityInstance;
            window.UnityInstance = exports.UnityInstance;
        })
            .catch((message) => {
            alert(message);
        });
    };
    document.body.appendChild(script);
    (0, UnityComm_1.InitFromUnity)();
}
